export default __webpack_public_path__ + "static/media/velaWhite.19869ea6.png";